/**
 * Client-side session validity check (mirrors validateSession in request.js).
 */

export const AUTH_REQUIRED_MESSAGE = 'Authorization required, please login to continue.'
export const SESSION_EXPIRED_MESSAGE = 'Session has expired, please login again to continue.'

export function getInvalidSessionMessage(user) {
  if (!user || !Object.keys(user).length) return AUTH_REQUIRED_MESSAGE
  const userToken = user.token || user.access_token
  if (!userToken || !user.exp) return AUTH_REQUIRED_MESSAGE
  if (user.exp * 1000 < Date.now()) return SESSION_EXPIRED_MESSAGE
  return null
}

export function hasValidSession(user) {
  return getInvalidSessionMessage(user) == null
}
